/**
 * @desc js bridge for kewl
 */
import updateLocation2 from '../location2';
import packageDetails from '../kewl/packageDetails';
import UserInfoSingleton from '../userInfoSingleton';
import {
  UA,
  matchUA,
  IsAndroid,
  IsIPad,
  IsIPhone,
  IsIOS,
  IsNewIosApp,
  IsKEWLApp,
  IsAndroidApp,
  IsPC
} from '../uaInfo';
import alias from '../alias';

const ROOT = window;
const DOC = ROOT.document;

const KEWLObj = IsKEWLApp && typeof ROOT.android === 'object' ? ROOT.android : null;

// scheme协议相关
const {
  packageName,
  packageArea,
  packageInfo
} = packageDetails;

const PREFIX = `${packageName}://`;
console.log(packageName, packageArea);

// bridge回调
function asyncCallbackName(callback, self) {
  const fnName = `${packageName
    + new Date().getTime()
  }${
    Math.random().
      toString().
      substr(2)}`;
  ROOT[fnName] = (data) => {
    let obj = '';
    if (typeof data === 'string') {
      try {
        obj = JSON.parse(data);
      } catch (error) {
        obj = data;
      }
    } else {
      obj = data;
    }
    // let obj = typeof data === 'string' ? JSON.parse(data) : data
    let result;
    if (callback) {
      if (self) {
        result = callback.call(self, obj);
      } else {
        result = callback(obj);
      }
    }
    // 根据 回调函数 返回值决定是否删除当前挂载函数
    if (!result) {
      delete ROOT[fnName];
    }
  };
  return fnName;
}

function getVerCode() {
  if (
    IsKEWLApp
    && !IsIOS
    && typeof KEWLObj === 'object'
    && Object.prototype.hasOwnProperty.call(KEWLObj, 'getVerCode')
  ) {
    return KEWLObj.getVerCode('');
  }
  if (IsKEWLApp && IsIOS) {
    if (!!matchUA && matchUA.length > 1) {
      const vers = matchUA[1].split('.');
      let num = 0;
      // eslint-disable-next-line radix
      num += vers[0] ? parseInt(vers[0]) * 10000000 : 0;
      // eslint-disable-next-line radix
      num += vers[1] ? parseInt(vers[1]) * 100000 : 0;
      // eslint-disable-next-line radix
      num += vers[2] ? parseInt(vers[2]) * 10000 : 0;
      // eslint-disable-next-line radix
      num += vers[3] ? parseInt(vers[3]) : 0;
      return num;
      // return matchUA[1];  // 3.8.65
    }
  }
  return 0;
}

function getVerName() {
  if (
    IsKEWLApp
    && !IsIOS
    && typeof KEWLObj === 'object'
    && Object.prototype.hasOwnProperty.call(KEWLObj, 'getVerName')
  ) {
    return KEWLObj.getVerName('');
  }
  if (IsKEWLApp && IsIOS) {
    if (!!matchUA && matchUA.length > 1) {
      // 美国包的ua里面版本号加了;app/us，所以得处理区分一下
      const iosMatchUA = matchUA[1].split(';');
      if (iosMatchUA.length > 1) {
        return iosMatchUA[0];
      }
      return matchUA[1];
    }
  }
  return '';
}

const KEWLApp = {
  kewlversion() {
    return '1.0.0';
  },
  UAInfo: {
    UA,
    IsAndroid,
    IsIPad,
    IsIPhone,
    IsIOS,
    IsNewIosApp,
    IsKEWLApp,
    IsPC
  },
  PackageDetails: {
    packageName,
    packageArea,
    packageInfo,
    PREFIX
  },
  asyncCallbackName,
  tryOpen(url, fallbackUrl = null) {
    if (IsIOS) {
      if (!url && url !== '') {
        return;
      }
      url = PREFIX + url;
      if (IsIOS) {
        ROOT.location2.href = url;
        return;
      }
      const frame = DOC.createElement('iframe');
      frame.style.cssText = 'width:1px;height:1px;position:fixed;top:0;left:0;';
      frame.src = url;
      DOC.body.appendChild(frame);
      setTimeout(() => {
        DOC.body.removeChild(frame);
      }, 150);
    }
    this.tryIntentOpen(url, fallbackUrl);
  },
  tryIntentOpen(url, fallbackUrl = null) {
    const anchorEle = DOC.createElement('a');
    let downloadPage = `${ROOT.location2.protocol}//${ROOT.location2.host}/download/middlepage.html?${ROOT.location2.search}`;
    if (fallbackUrl) {
      downloadPage = fallbackUrl;
    }
    const anchorHref = `intent://${
      url
    }#Intent;scheme=${
      packageName
    };package=${
      packageArea
    };S.browser_fallback_url=${
      downloadPage
    };end`;
    anchorEle.style.cssText = 'width:1px;height:1px;position:fixed;top:0;left:0;';
    anchorEle.href = anchorHref;
    anchorEle.id = 'appIntent';
    DOC.body.appendChild(anchorEle);
    document.getElementById('appIntent').click();
    DOC.body.removeChild(anchorEle);
  },
  iosPostMessage(obj) {
    if (IsNewIosApp && typeof obj === 'object') {
      ROOT.webkit.messageHandlers.webViewApp.postMessage(obj);
    }
  },
  isSupportOpenNativePage() {
    if (IsAndroidApp) {
      return !!KEWLObj.openNativePage;
    }
    return window.BridgeSupportInfo ? !!window.BridgeSupportInfo.openNativePage : false;
  },
  openNativePage(pageName, scene = null, payload = {}) {
    if (!this.isSupportOpenNativePage()) {
      return false;
    }

    const data = {
      pageName,
      scene: scene || '',
      payload
    };

    if (IsKEWLApp && !IsIOS) {
      KEWLObj.openNativePage(JSON.stringify(data));
    } else if (IsNewIosApp) {
      data.type = 'openNativePage';
      this.iosPostMessage(data);
    } else {
      this.tryOpen(`openNativePage?${Object.keys(data).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`).join('&')}`);
    }
    return true;
  },
  /**
   * @desc 通用调用客户端方法
   * @param {bridge} 客户端方法，{jsonString} 通用json字符串参数、{callback} 回调
   */
  kewlBridge(bridge, jsonStr, callback) {
    const jsonString = jsonStr || '';
    let obj;
    if (IsKEWLApp && !IsIOS) {
      obj = KEWLObj[bridge](jsonString);
      callback && callback(obj);
    } else if (IsNewIosApp) {
      const fnName = asyncCallbackName(callback);
      this.iosPostMessage({
        type: bridge,
        jsonString,
        callback: fnName
      });
    }
  },
  /**
   * @desc 通用调用客户端方法
   * @param { bridge } 客户端方法，
   * @param { json } 通用json 对象
   * @param { keys } json对象 key 顺序数组
   * @param { callback } 回调
   * [ 与原版 区别在于 参数 依次传入 而不是 格式化 给到 客户端，符合客户端习惯 ]
   */
  kewlBridgeV2(bridge, json, keys, callback) {
    const jsonData = json || {};
    const jsonKeys = keys || [];
    let obj;
    // eslint-disable-next-line no-confusing-arrow
    const values = jsonKeys.map(name => jsonData[name] !== undefined ? jsonData[name] : '');
    if (IsKEWLApp && !IsIOS) {
      obj = KEWLObj[bridge](...values);
      callback && callback(obj);
    } else if (IsNewIosApp) {
      const fnName = asyncCallbackName(callback);
      this.iosPostMessage(Object.assign({
        type: bridge,
        callback: fnName
      }, jsonData));
    }
  },
  /**
   * 自定义方法 获取  客户端返回值
   * @param  {Function} fnName 与客户端约定的 获取方法的名称
   * @param  {Function} callback 异步回掉
   * @return {Undefined}         无返回值，通过callback返回
   */
  getNativeData(fnName, callback) {
    if (!fnName) {
      return;
    }
    const name = fnName || '';
    let obj;
    if (
      IsKEWLApp
      && !IsIOS
      && typeof KEWLObj === 'object'
      && Object.prototype.hasOwnProperty.call(KEWLObj, name)
    ) {
      obj = KEWLObj[name]();
      obj = typeof obj === 'string' && obj !== 'null' && obj !== ''
        ? JSON.parse(obj)
        : obj;
      callback && callback(obj);
    } else if (IsKEWLApp && IsIOS) {
      const callbackName = asyncCallbackName(callback);
      if (IsNewIosApp) {
        this.iosPostMessage({
          type: name,
          callback: callbackName
        });
      } else {
        this.tryOpen(`${name}?callback=${callbackName}`);
      }
    }
  },
  /**
   * 获取客户端版本
   * @return {Number} 如：10230000
   */
  getVerCode() {
    return getVerCode();
  },
  /**
   * 获取客户端版本
   * @return {String} 如：1.2.3
   */
  getVerName() {
    return getVerName();
  },
  /**
   * 获取android 多包信息 返回信息com.****.live
   */
  getPackName() {
    if (!!KEWLObj && !!KEWLObj.getPackName) {
      return KEWLObj.getPackName();
    }
    return '';
  },
  /* 比较版本号大小，非客户端方法
   * @desc 通过getVerName取当前版本进行匹配
   * @use versionCompare(currentVer, '4.0.95')
   */
  versionCompare(ver) {
    const currentVer = getVerName();
    // 版本号有返回为空的情况
    if (currentVer === null) {
      return false;
    }
    const version1pre = parseFloat(currentVer);
    const version2pre = parseFloat(ver);
    const version1next = currentVer.replace(`${version1pre}.`, '');
    const version2next = ver.replace(`${version2pre}.`, '');
    if (version1pre > version2pre) {
      return true;
    }
    if (version1pre < version2pre) {
      return false;
    }
    if (version1next >= version2next) {
      return true;
    }
    return false;
  },
  /**
   * 设置title
   * @param {String} title 标题文字
   */
  setTitle(title) {
    if (!title || typeof title !== 'string') {
      return;
    }
    if (!!ROOT.Base64 && IsKEWLApp && !IsIOS && this.getVerCode() >= 20900000) {
      KEWLObj.changeTitle(ROOT.Base64.encode(title));
    } else if (
      !!ROOT.Base64
      && IsKEWLApp
      && IsIOS
      && this.getVerCode() >= 103100000
    ) {
      this.tryOpen(`changeTitle?title=${ROOT.Base64.encode(title)}`);
    } else if (!!ROOT.Base64 && IsNewIosApp) {
      this.iosPostMessage({
        type: 'changetitle',
        title: ROOT.Base64.encode(title)
      });
    } else {
      document.title = title;
    }
  },
  /**
   * 是否有客户端分享界面，自执行，返回变量；
   */
  hasShare: (function () {
    return (
      (IsKEWLApp
        && !IsIOS
        && typeof KEWLObj === 'object'
        && (Object.prototype.hasOwnProperty.call(KEWLObj, 'openShareMenu')
          || Object.prototype.hasOwnProperty.call(KEWLObj, 'showShareMenu')))
      || (IsKEWLApp && IsIOS && getVerCode() >= 10800000)
    );
  }()),
  /**
   * @desc 获取app 包 信息
   * @return {String} 包信息  liveme 包   中东包
   */
  getPackgetInfo() {
    return packageInfo;
  },
  /**
   * @desc 获取alias
   * @returns {String} alias
   */
  getAlias() {
    // 兼容coinsgame独立域名支持多包
    // 根据getPackName获取包名
    const packName = window.KEWLApp.getPackName && window.KEWLApp.getPackName();
    if (packName.split('.')[1]) {
    // eslint-disable-next-line prefer-destructuring
      const packForCoinsgame = packName.split('.')[1];
      if (packForCoinsgame === 'joyu') {
        return 'highlive';
      }
      if (packForCoinsgame === 'sparkher') {
        return 'highlive';
      }
      if (packForCoinsgame === 'highlive') {
        return 'highlive';
      }
      if (packForCoinsgame === 'chasex') {
        return 'highlive';
      }
    }
    return alias;
  },
  /**
   * 获取用户登录信息
   * @param  {Function} callback 异步回掉
   */
  getUserInfo(callback) {
    // {
    //  "deviceId":"asdfasdf",
    //  "userId":"12341234",
    //  "token":"asdfasdf"
    // }
    const userInfoSingleton = UserInfoSingleton.getInstance();
    userInfoSingleton.getUserInfo(callback);
  },
  /**
   * 调起App
   */
  openApp() {
    if (IsKEWLApp) {
      return;
    }
    this.tryOpen('');
  },
  /**
   * 打开webview
   * @param  {String} url
   */
  openwebview(url) {
    if (IsKEWLApp || !ROOT.Base64) {
      return;
    }
    this.tryOpen(`openwebview?url=${ROOT.Base64.encode(url)}`);
  },
  /**
   * 关闭webview
   */
  closePage() {
    if (IsKEWLApp && !IsIOS) {
      KEWLObj.closePage('');
    } else if (IsNewIosApp) {
      this.iosPostMessage({
        type: 'close'
      });
    } else if (IsKEWLApp && IsIOS) {
      this.tryOpen('close');
    }
  },

  /**
   * 获取web host
   * @param {*} callback
   */
  getHost(callback) {
    const fnName = asyncCallbackName(callback);
    if (IsKEWLApp && !IsIOS) {
      KEWLObj.getHost(fnName);
    } else if (IsNewIosApp) {
      this.iosPostMessage({
        type: 'getHost',
        fnName
      });
    }
  },

  /**
   * 通知客户端下载离线包
   * @param name 离线包项目名称
   * @param version 离线包版本
   */
  downloadWebZipRes(name, version) {
    const prex = `/app/${name}`;
    const zipPath = `${ROOT.location2.origin}/app/${name}/dist/${name}_${version}.zip`;
    if (IsKEWLApp && !IsIOS) {
      KEWLObj.downloadWebZipRes && KEWLObj.downloadWebZipRes(prex, zipPath);
    } else if (IsNewIosApp) {
      this.iosPostMessage({
        type: 'downloadWebZipRes',
        prex,
        zipPath
      });
    }
  },

  /**
   * 卸载离线包 4.5.65增加
   * @param name 离线包项目名称
   * @param version 离线包版本
   */
  deleteWebZipRes(prex) {
    if (IsKEWLApp && !IsIOS) {
      KEWLObj.deleteWebZipRes && KEWLObj.deleteWebZipRes(prex);
    } else if (IsNewIosApp) {
      this.iosPostMessage({
        type: 'deleteWebZipRes',
        prex
      });
    }
  }
};

Object.defineProperties(KEWLApp, {
  isKEWLApp: {
    get() {
      return IsKEWLApp;
    }
  }
});
if (IsKEWLApp) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      KEWLApp.setTitle(document.title);
    },
    false
  );
}

// 避免zip 包使用 iframe 时候 报错
try {
  if (ROOT.self == ROOT.top) {
    ROOT.KEWLApp = KEWLApp;
  } else {
    ROOT.KEWLApp = ROOT.top.KEWLApp ? ROOT.top.KEWLApp : KEWLApp;
  }
} catch (error) {
  ROOT.KEWLApp = KEWLApp;
}

export default KEWLApp;
